import React from 'react'
import { Icon } from '@at/design-system-elements'

export const ChevronUp = ({ name, size }: { name: string; size: string }) => {
    return (
        <Icon
            name={name}
            size={size}
            svgContent={
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 13.586L7.414 15L12 10.414L16.586 15L18 13.586L12.707 8.293C12.526 8.112 12.276 8 12 8C11.724 8 11.474 8.112 11.293 8.293L6 13.586Z"
                />
            }
        />
    )
}

export const ChevronDown = ({ name, size }: { name: string; size: string }) => {
    return (
        <Icon
            name={name}
            size={size}
            svgContent={
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 10.414L16.586 9L12 13.586L7.414 9L6 10.414L11.293 15.707C11.474 15.888 11.724 16 12 16C12.276 16 12.526 15.888 12.707 15.707L18 10.414Z"
                />
            }
        />
    )
}

export const ChevronRight = ({ name, size }: { name: string; size: string }) => {
    return (
        <Icon
            name={name}
            size={size}
            svgContent={
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.414 6L9 7.414L13.586 12L9 16.586L10.414 18L15.707 12.707C15.888 12.526 16 12.276 16 12C16 11.724 15.888 11.474 15.707 11.293L10.414 6Z"
                />
            }
        />
    )
}

export const ChevronLeft = ({ name, size }: { name: string; size: string }) => {
    return (
        <Icon
            name={name}
            size={size}
            svgContent={
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.586 18L15 16.586L10.414 12L15 7.414L13.586 6L8.293 11.293C8.112 11.474 8 11.724 8 12C8 12.276 8.112 12.526 8.293 12.707L13.586 18Z"
                />
            }
        />
    )
}
